import { PdpSharedRingSizeDetail_detailValues as DetailValues } from './__generated__/PdpSharedRingSizeDetail_detailValues.graphql';
import { FC, useState } from 'react';
import { createFragmentContainer, graphql, RelayProp } from 'react-relay/legacy';
import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import { PdpSharedRingSizeGuideModalLink } from '../PdpSharedRingSize/PdpSharedRingSizeGuideModalLink';
import { PdpSharedRingSizeGuideModalLazy } from '../PdpSharedRingSize/PdpSharedRingSizeGuideModalLazy';

type Props = {
    isClient: boolean;
    detailValues: DetailValues;
    relay: RelayProp;
};

const PdpSharedRingSizeDetailComponent: FC<Props> = ({ isClient, detailValues, relay }) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <CurrencyProvider
                render={({ currency }: { currency: string }) => {
                    const ringMeasurementType = currency === 'USD' ? 'US' : 'MM';
                    const ringSizeDisplay = detailValues?.[0]?.ringSizes?.find(
                        size => size?.unit === ringMeasurementType
                    )?.value;

                    return <>{ringSizeDisplay}</>;
                }}
            />
            <div>
                <PdpSharedRingSizeGuideModalLink onClick={() => setModalOpen(true)} />
                {isClient && (
                    <PdpSharedRingSizeGuideModalLazy
                        isOpen={modalOpen}
                        onClose={() => setModalOpen(false)}
                        relay={relay}
                    />
                )}
            </div>
        </>
    );
};

export const PdpSharedRingSizeDetail = createFragmentContainer(PdpSharedRingSizeDetailComponent, {
    detailValues: graphql`
        fragment PdpSharedRingSizeDetail_detailValues on PdpDetailValueInterface
        @relay(plural: true) {
            detailKey
            ... on PdpDetailRingSize {
                ringSizes {
                    unit
                    value
                }
            }
        }
    `,
});
